import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { DropdownIcon, PlusIcon, ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectStatusFilter } from "../../redux/selector";
import { actions, inventorySlice } from "../../redux/slice";
import { StatusFilter } from "../../types";
import { useStyles } from "./styles";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";

const STATUS_OPTIONS: StatusFilter[] = [
  "ALL",
  "IN_PRODUCTION",
  "WAITING_ENGINEERING",
  "QUALITY_CONTROL",
];


export const ActionBar = () => {

    const { t } = useTranslation();
    const styles = useStyles();
    const dispatch = useDispatch();
    const statusFilter = useSelector(selectStatusFilter);
    
    const handleStatusChange = (value: StatusFilter) => {
        dispatch(inventorySlice.actions.setStatusFilter(value))
    } 

    const getStatusLabel = (value: StatusFilter) =>
        t(
          value === "ALL"
            ? "INVENTORY.STATUS_ALL"
            : `INVENTORY.STATUS_VALUES.${value}`
        );
    
  return (
    <div className={styles.root} dir="ltr">
          <div className={styles.actions}>
            <AddButton label={t("INVENTORY.ADD")}/>
          </div>
          <FilterSelect 
              label={t("ADMIN_MANAGEMENT.TABLE.STATUS")}
              value={statusFilter}
              options={STATUS_OPTIONS}
              getOptionLabel={(value) => getStatusLabel(value)}
              onChange={handleStatusChange}/>
        </div>
    )}
    
